<script setup>
import { inject } from 'vue'
import LineChartSkeleton from './LineChartSkeleton.vue'

defineProps({
  isDisabled: Boolean,
  isUncovered: Boolean,
  home: {
    type: Object,
    default: () => ({
      label: '45/56',
      additionalLabel: '52.3%',
      value: 52.3
    })
  },
  away: {
    type: Object,
    default: () => ({
      label: '39/79',
      additionalLabel: '49.4%',
      value: 49.4
    })
  },
  title: String
})

const status = inject('status')
</script>

<template>
  <line-chart-skeleton v-if="status === 'loading'" />
  <div v-else class="szw-col szw-w-full szw-px-1 szw-text-xs szw-h-[30px] szw-gap-1">
    <div :class="['szw-row szw-w-full', isDisabled && isUncovered ? 'szw-text-latest-text-icon-tertiary' : 'szw-text-latest-text-icon-primary']">
      <span class="szw-font-medium szw-text-font-size-md szw-leading-font-line-height-md szw-text-center szw-w-9">{{ home.label }}</span>

      <span class="szw-mx-auto szw-text-center szw-text-font-size-sm szw-font-light szw-leading-font-line-height-sm">{{ title }}</span>

      <span class="szw-font-medium szw-text-font-size-md szw-leading-font-line-height-md szw-text-center szw-w-9">{{ away.label }}</span>
    </div>

    <div class="szw-flex szw-w-full szw-h-1.5 szw-rounded szw-overflow-hidden" style="border: 1px solid var(--szw-border)">
      <div v-if="isDisabled || isUncovered" class="szw-h-full szw-line-chart-disabled" :style="{ width: `100%` }"></div>

      <template v-else>
        <div class="szw-h-full szw-line-chart-left" :style="{ width: `${home.value}%` }"></div>
        <div class="szw-h-full szw-line-chart-right" :style="{ width: `${away.value}%` }"></div>
      </template>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.szw-line-chart-disabled {
  background-color: var(--szw-color-disable);
}
.szw-line-chart-left {
  transform: skewX(-20deg);
  position: relative;

  &:after {
    content: ' ';
    position: absolute;
    display: block;
    width: 4px;
    height: 100%;
    top: 0;
    left: -2px;
    z-index: 1;
    background: var(--szw-team-home);
  }

  background-color: var(--szw-team-home);
}

.szw-line-chart-right {
  transform: skewX(-20deg);
  position: relative;

  &:before {
    content: ' ';
    position: absolute;
    display: block;
    width: 4px;
    height: 100%;
    top: 0;
    right: -2px;
    z-index: 1;
    transform-origin: bottom right;
    background-color: var(--szw-team-away);
  }

  background-color: var(--szw-team-away);
}
</style>
